import { useState, useEffect, useSyncExternalStore } from "react";

const STORAGE_KEY = "dd_selected_location";

let globalLocationId: string | null = (() => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
})();

const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot() {
  return globalLocationId;
}

function setSelectedLocationId(id: string) {
  globalLocationId = id;
  try {
    localStorage.setItem(STORAGE_KEY, id);
  } catch {}
  listeners.forEach((l) => l());
}

export function clearStaleSelection(validIds: string[]) {
  if (globalLocationId && !validIds.includes(globalLocationId)) {
    globalLocationId = validIds[0] ?? null;
    try {
      if (globalLocationId) {
        localStorage.setItem(STORAGE_KEY, globalLocationId);
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    } catch {}
    listeners.forEach((l) => l());
  }
}

export function useLocationStore() {
  const selectedLocationId = useSyncExternalStore(subscribe, getSnapshot);
  return { selectedLocationId, setSelectedLocationId };
}
